import { render } from "./mls-disclaimer.vue?vue&type=template&id=fd17f064"
import script from "./mls-disclaimer.vue?vue&type=script&lang=js"
export * from "./mls-disclaimer.vue?vue&type=script&lang=js"

import "./mls-disclaimer.vue?vue&type=style&index=0&id=fd17f064&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__